import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatTableDataSource, MatDialog } from '@angular/material';
import { UsuarioCoordinador } from '../../classes/coordinador';
import { PERFILES } from '../../shared/constants/app-values';
import { ModalUsuarioComponent } from './modal-usuarios/modal-usuarios.component';
import { Router } from '@angular/router';
import { AppStorage } from '../../shared/services/appStorage.service';
import { ApiUsuariosService } from '../../shared/services/api-usuarios.service';

@Component({
  selector: 'app-usuarios',
  templateUrl: './usuarios.component.html',
  styleUrls: ['./usuarios.component.css']
})
export class UsuariosComponent implements OnInit {
  // Data
  displayedColumns: string[] = [
    'nombre',
    'departamento',
    'editor',
    'administrador'
  ];
  dataSource: MatTableDataSource<UsuarioCoordinador>;
  usuarios: UsuarioCoordinador[];
  perfiles = PERFILES;

  // Loading
  loadingUsuarios = true;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    public dialog: MatDialog,
    public appStorage: AppStorage,
    private router: Router,
    private apiUsuariosService: ApiUsuariosService
  ) {}
  ngOnInit() {
    if (
      this.appStorage.datosSesion.perfil !==
      this.appStorage.perfilesUsuario.COORDINADOR_ADMINISTRADOR
    ) {
      this.appStorage.goHome();
    } else {
      this.cargarUsuarios();
    }
  }

  cargarUsuarios() {
    this.loadingUsuarios = true;
    this.apiUsuariosService
      .getUsuariosCoordinadores()
      .then((res: any) => {
        this.usuarios = res.ListadoUsuarioCoordinador;
        this.dataSource = new MatTableDataSource<UsuarioCoordinador>(
          this.usuarios
        );
        this.dataSource.paginator = this.paginator;
        this.loadingUsuarios = false;
      })
      .catch(error => {});
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  asignarPerfilAdministrador(usuario) {
    const dialogRef = this.dialog.open(ModalUsuarioComponent, {
      width: '450px',
      data: {
        usuario: usuario,
        icon: 'add_circle_outline',
        texto: 'Se asignará el permiso administrador al usuario ',
        textoBoton: 'Asignar',
        callback: () => {
          this.appStorage.loadingGeneral = true;
          this.apiUsuariosService
            .cambiarPerfilUsuarioCoordinador(
              usuario,
              this.appStorage.perfilesUsuario.COORDINADOR_ADMINISTRADOR
            )
            .then(() => {
              this.appStorage.loadingGeneral = false;
              usuario.idPerfil = this.appStorage.perfilesUsuario.COORDINADOR_ADMINISTRADOR;
            })
            .catch(error => {
              this.appStorage.loadingGeneral = false;
            });
        }
      }
    });

    return dialogRef;
  }
  asignarPerfilEditor(usuario) {
    const dialogRef = this.dialog.open(ModalUsuarioComponent, {
      width: '450px',
      data: {
        usuario: usuario,
        icon: 'add_circle_outline',
        texto: 'Se asignará el permiso editor al usuario ',
        textoBoton: 'Asignar',
        callback: () => {
          this.appStorage.loadingGeneral = true;
          this.apiUsuariosService
            .cambiarPerfilUsuarioCoordinador(
              usuario,
              this.appStorage.perfilesUsuario.COORDINADOR_EDITOR
            )
            .then(() => {
              this.appStorage.loadingGeneral = false;
              usuario.idPerfil = this.appStorage.perfilesUsuario.COORDINADOR_EDITOR;
            })
            .catch(error => {
              this.appStorage.loadingGeneral = false;
            });
        }
      }
    });

    return dialogRef;
  }
  quitarPerfilAdministrador(usuario) {
    const dialogRef = this.dialog.open(ModalUsuarioComponent, {
      width: '450px',
      data: {
        usuario: usuario,
        icon: 'error_outline',
        texto: 'Se eliminará el permiso administrador al usuario ',
        textoBoton: 'Eliminar',
        callback: () => {
          this.appStorage.loadingGeneral = true;
          this.apiUsuariosService
            .cambiarPerfilUsuarioCoordinador(
              usuario,
              this.appStorage.perfilesUsuario.COORDINADOR_EDITOR
            )
            .then(() => {
              this.appStorage.loadingGeneral = false;
              usuario.idPerfil = this.appStorage.perfilesUsuario.COORDINADOR_EDITOR;
            })
            .catch(error => {
              this.appStorage.loadingGeneral = false;
            });
        }
      }
    });

    return dialogRef;
  }
  quitarPerfilEditor(usuario) {
    if (usuario.idPerfil === this.perfiles.ADMINISTRADOR) {
      return;
    }
    const dialogRef = this.dialog.open(ModalUsuarioComponent, {
      width: '450px',
      data: {
        usuario: usuario,
        icon: 'error_outline',
        texto: 'Se eliminará el permiso editor al usuario ',
        textoBoton: 'Eliminar',
        callback: () => {
          this.appStorage.loadingGeneral = true;
          this.apiUsuariosService
            .cambiarPerfilUsuarioCoordinador(
              usuario,
              this.appStorage.perfilesUsuario.PUBLICO
            )
            .then(() => {
              this.appStorage.loadingGeneral = false;
              usuario.idPerfil = this.appStorage.perfilesUsuario.PUBLICO;
            })
            .catch(error => {
              this.appStorage.loadingGeneral = false;
            });
        }
      }
    });

    return dialogRef;
  }
}
